import React from 'react'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { CellWithContextMenu } from '@ztechapps/webui.menu'
import { RowContextMenu } from './RowContextMenu'
import { RowExtension } from '../RowExtension'
import { ExtendingRow } from '../../Table/extending-row'

export const Row = (props) => {
  const { name, description, isDefault } = props
  const extensionRow = <RowExtension {...{ ...props }} />

  return (
    <ExtendingRow {...{ ...props, colSpan: 2, extensionRow }}>
      <CellWithContextMenu contextMenuContent={<RowContextMenu template={props} />}>
        <div>
          <ShowIf condition={isDefault}>
            <span className="text-warning">
              <Icon title="Default template" name="star" />{' '}
            </span>
          </ShowIf>
          <b>{name}</b>
          {/* Defect 4 (visual sweep, 2026-09-12): when a template's description equals its
              name — e.g. seed data — the dash-joined form read as a duplicated, broken row
              ("New Customer Defined - New Customer Defined"). Every `Template` category renders
              through this shared row, so the equal case is handled here rather than per-category. */}
          <ShowIf condition={Boolean(description) && description !== name}>
            {' - '}
            <small>{description}</small>
          </ShowIf>
        </div>
      </CellWithContextMenu>
    </ExtendingRow>
  )
}
